import {ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector} from '@angular/core';
import {PreHeadingComponent} from './pre-heading.component';
import {PreHeadingModel} from './pre-heading.model';
import {Device} from '../../model/Device';
import { Module } from 'projects/common/model/ModuleModel';

@Injectable({
  providedIn: 'root'
})
export class PreHeadingService {

  constructor(private applicationRef: ApplicationRef,
              private componentFactoryResolver: ComponentFactoryResolver,
              private injector: Injector) { }

  public createComponent(module: Module<PreHeadingModel>) {
    if (globalThis.document) {
      const data = module.data;
      const element = globalThis.document.getElementById('PreHeadingModule');
      const componentRef = this.componentFactoryResolver.resolveComponentFactory(PreHeadingComponent).create(this.injector);
      componentRef.instance.data = data;
      componentRef.instance.uniqueId = module.unique_id;
      componentRef.instance.position = module.position;
      this.applicationRef.attachView(componentRef.hostView);
      element?.appendChild((componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement);
    }
  }
}
